import { render } from "./App.vue?vue&type=template&id=22a8cb2d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=22a8cb2d&lang=css"

import exportComponent from "C:\\Users\\Eric\\source\\repos\\creditdriver\\CreditDriver\\CandidateApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])